export default __webpack_public_path__ + "static/media/master2.cb450d62.png";